export default __webpack_public_path__ + "media/images/hero-image-acd36da9016aa58b810436b21d9a67f7.jpg";